import React from "react";

import SvgIcon from "../../common/SvgIcon";
import iconSprite from "../../../../../images/img/chat/icons.svg";

const onRequestPermissions = () => {
    window.open("/chat/permissions", i18n.t("rtm.text.allow_browser_notifications"), "width=324, height=127");
};

const BrowserNotificationSystemMessage = () => (
    <li className="system-message browser-notification-prompt">
        <div className="icon icon-bell">
            <SvgIcon src={iconSprite} id="icon-bell" />
        </div>
        <p className="body">
            <a onClick={onRequestPermissions}>
                <strong>{i18n.t("rtm.text.enable_browser_notifications")}</strong>
            </a>
        </p>
    </li>
);

export default BrowserNotificationSystemMessage;
